import Layout from "../../Internal/Layout.vue";
import MarketingPage from "./Marketing.vue";
import AddBannerPage from "./AddBanner.vue";

const MarketingRoutes = {
  component: Layout,
  children: [
    {
      path: "/marketing",
      name: "Marketing",
      component: MarketingPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
      },
    },
    {
      path: "/add-banner",
      name: "AddBanner",
      component: AddBannerPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
      },
    },
  ],
};

export default MarketingRoutes;
